import { Dispatch, SetStateAction } from 'react'

import { useLightMode } from '@/hooks/useLightMode'
import { useDispatch } from 'react-redux'

import { setGuardToursPageSize } from '@/redux/ui/uiSlice'

import { useColumns } from '../components/Columns'
import { GuardToursListType } from '../types/table'
import { formatTableData } from '../utils/format'

interface UseGuardToursTableIProps {
  tours?: GuardToursListType
  totalTours?: number
  pageIndex: number
  setPageIndex: Dispatch<SetStateAction<number>>
  pageSize: number
  setPageSize: Dispatch<SetStateAction<number>>
  sortColumn: string | null
  setSortColumn: Dispatch<SetStateAction<string | null>>
  sortOrder: 'asc' | 'desc' | null
  setSortOrder: Dispatch<SetStateAction<'asc' | 'desc' | null>>
}

export const useGuardToursTable = ({
  tours,
  totalTours,
  pageIndex,
  setPageIndex,
  pageSize,
  setPageSize,
  setSortColumn,
  setSortOrder,
}: UseGuardToursTableIProps) => {
  const dispatch = useDispatch()
  const colorScheme = useLightMode()

  const columns = useColumns()
  const tableData = formatTableData(tours ?? [])
  const pageCount = Math.ceil((totalTours ?? 0) / pageSize)
  const sortableColumns = ['submittedTime']

  const handleSortChange = (
    column: string | null,
    order: 'asc' | 'desc' | null
  ) => {
    setSortColumn(column)
    setSortOrder(order)
    setPageIndex(0)
  }

  const handlePageSizeChange = (size: number) => {
    dispatch(setGuardToursPageSize(size))
    setPageSize(size)
    setPageIndex(0)
  }

  return {
    colorScheme,
    columns,
    tableData,
    pageIndex,
    setPageIndex,
    pageSize,
    pageCount,
    sortableColumns,
    handleSortChange,
    handlePageSizeChange,
  }
}
